"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = require("lodash");

var _react = _interopRequireWildcard(require("react"));

var _editor = require("../../../components/visualizations/editor");

var _button = _interopRequireDefault(require("antd/lib/button"));

var _propTypes = require("../../prop-types");

var _DeleteOutlined = _interopRequireDefault(require("@ant-design/icons/DeleteOutlined"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ButtonSettings = (_ref) => {
  var options = _ref.options,
      onOptionsChange = _ref.onOptionsChange;

  var _useState = (0, _react.useState)(options.buttonArr ? options.buttonArr : [{
    name: "",
    linkUrlTemplate: "",
    linkOpenInNewTab: true,
    columnName: ""
  }]),
      _useState2 = _slicedToArray(_useState, 2),
      arr = _useState2[0],
      setArr = _useState2[1];

  var handleChange = (event, item, index) => {
    if (event.target.id === "Button-Name" + index) {
      item.name = event.target.value;
    } else if (event.target.id === "URL-Template" + index) {
      item.linkUrlTemplate = event.target.value;
    } else if (event.target.type === "checkbox") {
      item.linkOpenInNewTab = event.target.checked;
    }

    setArr(prevArr => [...prevArr]);
  };

  var handleDropdown = (event, item) => {
    if (event) item.columnName = event;
    setArr(prevArr => [...prevArr]);
  };

  var createInputs = () => {
    setArr(prevItems => [...prevItems, {
      name: "",
      linkUrlTemplate: "",
      linkOpenInNewTab: true,
      columnName: ""
    }]);
  };

  var deleteButton = button => {
    var buttonArr = arr.filter(item => item !== button);
    setArr(() => [...buttonArr]);
  };

  (0, _react.useEffect)(() => {
    options.buttonArr = arr;
    onOptionsChange({
      buttonArr: arr
    });
  }, [arr]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_button.default, {
    onClick: createInputs
  }, "Add Action"), (0, _lodash.map)(arr, (item, index) => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_editor.Section, {
      key: index,
      item: item
    }, /*#__PURE__*/_react.default.createElement(_editor.Input, {
      label: "Button Name",
      id: "Button-Name" + index // data-test="Table.ColumnEditor.Link.Name"
      ,
      defaultValue: item.name,
      onChange: event => handleChange(event, item, index)
    })), /*#__PURE__*/_react.default.createElement(_editor.Section, null, /*#__PURE__*/_react.default.createElement(_editor.Input, {
      label: "URL template",
      id: "URL-Template" + index // data-test="Table.ColumnEditor.Link.UrlTemplate"
      ,
      defaultValue: item.linkUrlTemplate,
      onChange: event => handleChange(event, item, index)
    })), /*#__PURE__*/_react.default.createElement(_editor.Section, null, /*#__PURE__*/_react.default.createElement(_editor.Select, {
      label: "Parameters",
      id: "Column-Dropdown" + index // data-test="Table.ColumnEditor.Link.UrlTemplate"
      ,
      defaultValue: item.columnName,
      onChange: event => handleDropdown(event, item)
    }, options.columns.map(column => /*#__PURE__*/_react.default.createElement("option", {
      key: column.name
    }, column.name)))), /*#__PURE__*/_react.default.createElement(_editor.Section, null, /*#__PURE__*/_react.default.createElement(_editor.Checkbox // data-test="Table.ColumnEditor.Link.OpenInNewTab"
    , {
      value: item.linkOpenInNewTab,
      checked: item.linkOpenInNewTab,
      onChange: event => handleChange(event, item, index)
    }, "Open in new tab")), /*#__PURE__*/_react.default.createElement(_editor.Section, null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: () => deleteButton(item)
    }, /*#__PURE__*/_react.default.createElement(_DeleteOutlined.default, null))));
  }));
};

ButtonSettings.defaultProps = _propTypes.EditorPropTypes;
var _default = ButtonSettings;
exports.default = _default;
//# sourceMappingURL=ButtonSettings.js.map